// extracted by mini-css-extract-plugin
export default {"root":"StarRating_root__n1MJ6","root_star":"StarRating_root_star__xaYAU","root_active":"StarRating_root_active__Cny-7"};